import { createFileRoute } from "@tanstack/react-router"
import { FrontAppIntegrationModal } from "modules/settings/components/integrations/frontapp/FrontAppIntegrationModal"

export const Route = createFileRoute("/_base/_auth/settings/integrations/frontapp/connect")({
  component: FrontAppIntegrationModal,
})
